/* CNTRD cart cross-sell — complementary/related products inside the cart drawer.
   Lives in a persistent asset (not inline) so it survives Dawn's cart-drawer
   re-render. Uses Shopify's native recommendations API + AJAX cart. */
(function () {
  'use strict';
  var MONEY = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
  var rendering = false;

  function fmt(cents) {
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: MONEY }).format(cents / 100);
    } catch (e) { return '£' + (cents / 100).toFixed(2); }
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function recommend(productId, intent) {
    var url = '/recommendations/products.json?product_id=' + productId + '&limit=10&intent=' + intent;
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { return (d && d.products) || []; })
      .catch(function () { return []; });
  }

  function card(p) {
    var v = (p.variants || []).find(function (x) { return x.available; }) || p.variants[0];
    if (!v) return '';
    var img = (p.featured_image || (p.images && p.images[0]) || '');
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    var imgsrc = img ? img.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_200x$1') : '';
    return (
      '<div class="cn-upsell__card">' +
        '<a class="cn-upsell__media" href="' + p.url + '" tabindex="-1">' +
          (imgsrc ? '<img loading="lazy" src="' + imgsrc + '" alt="' + (p.title || '') + '" width="64" height="80">' : '') +
        '</a>' +
        '<div class="cn-upsell__info">' +
          '<a class="cn-upsell__name" href="' + p.url + '">' + p.title + '</a>' +
          '<span class="cn-upsell__price">' + fmt(v.price) + '</span>' +
        '</div>' +
        '<button type="button" class="cn-upsell__add" data-vid="' + v.id + '" aria-label="Add ' + p.title + ' to cart">Add</button>' +
      '</div>'
    );
  }

  function render() {
    if (rendering) return;
    var box = document.querySelector('[data-cn-upsell]');
    var track = document.querySelector('[data-cn-upsell-track]');
    if (!box || !track) return;
    rendering = true;
    getCart().then(function (cart) {
      if (!cart || !cart.items || !cart.items.length) {
        box.hidden = true; track.innerHTML = ''; box.dataset.key = ''; rendering = false; return;
      }
      var inCart = {};
      cart.items.forEach(function (i) { inCart[i.product_id] = true; });
      var seed = cart.items[cart.items.length - 1].product_id;
      var key = seed + '|' + cart.item_count;
      // already rendered for this exact cart state → skip (prevents observer loop)
      if (box.dataset.key === key && track.children.length) { rendering = false; return; }
      return recommend(seed, 'complementary').then(function (list) {
        if (!list.length) return recommend(seed, 'related');
        return list;
      }).then(function (list) {
        var picks = list.filter(function (p) {
          return !inCart[p.id] && (p.variants || []).some(function (v) { return v.available; });
        }).slice(0, 4);
        stopObserving();
        if (!picks.length) { box.hidden = true; track.innerHTML = ''; }
        else { track.innerHTML = picks.map(card).join(''); box.hidden = false; }
        box.dataset.key = key;
        rendering = false;
        startObserving();
      });
    }).catch(function () { rendering = false; });
  }

  function refreshDrawer(state) {
    var cd = document.querySelector('cart-drawer');
    if (cd && typeof cd.renderContents === 'function' && state) {
      cd.renderContents(state);
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
  }

  function addToCart(vid, btn) {
    btn.classList.add('is-loading');
    btn.disabled = true;
    var body = {
      items: [{ id: Number(vid), quantity: 1 }],
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); })
      .then(function (state) { refreshDrawer(state); })
      .catch(function () { btn.classList.remove('is-loading'); btn.disabled = false; });
  }

  // One-tap add (delegated — survives re-render)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.cn-upsell__add');
    if (!btn) return;
    e.preventDefault();
    addToCart(btn.dataset.vid, btn);
  });

  // Re-populate whenever the cart drawer subtree changes (debounced)
  var t;
  var obs = new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(render, 120);
  });
  function startObserving() {
    var cd = document.querySelector('cart-drawer');
    if (cd) obs.observe(cd, { childList: true, subtree: true });
  }
  function stopObserving() { obs.disconnect(); }
  function boot() {
    startObserving();
    render();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
